module.exports = __webpack_public_path__ + "static/VasudevanSuresh-86504c2ed27e09d83525e9b45b9c4e5f.jpg";